import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as UserDetailsActions from './user-details.actions';
import * as UserDetailsSelectors from './user-details.selectors';

@Injectable()
export class UserDetailsFacade {
  private readonly store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  profileData$ = this.store.pipe(select(UserDetailsSelectors.getProfileData));
  userProfileOverview$ = this.store.pipe(select(UserDetailsSelectors.getuserProfileOverview));
  userPersonalInfo$ = this.store.pipe(select(UserDetailsSelectors.userPersonalInfo));
  getUserEmailPreferences$ = this.store.pipe(
    select(UserDetailsSelectors.userEmailPreferencesStatusGet)
  );
  userProfileImage$ = this.store.pipe(select(UserDetailsSelectors.getUserProfileImageData));
  userProfileImageStatus$ = this.store.pipe(select(UserDetailsSelectors.clearImagestatus));
  // For material-types & Recyclability & Compostability & Combustibility
  organizationList$ = this.store.pipe(select(UserDetailsSelectors.getOranizationList));
  selectedOrg$ = this.store.pipe(select(UserDetailsSelectors.getSelectedOrg));
  getOrganizationName$ = this.store.pipe(select(UserDetailsSelectors.getOrganizationName));

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */

  profileData() {
    this.store.dispatch(UserDetailsActions.loggedInUserProfile());
  }

  userProfileOverview() {
    this.store.dispatch(UserDetailsActions.userProfileOverview());
  }

  saveUserPersonalData(payload: any) {
    this.store.dispatch(UserDetailsActions.saveUserPersonalInfo({ payload }));
  }

  userPersonalInfo() {
    this.store.dispatch(UserDetailsActions.getUserPersonalInfo());
  }

  getUserProfileImage() {
    this.store.dispatch(UserDetailsActions.getUserProfileImage());
  }

  updateUserProfileImage(payload: any) {
    this.store.dispatch(UserDetailsActions.updateUserProfileImage({ payload }));
  }

  getUserEmailPreferences() {
    this.store.dispatch(UserDetailsActions.getUserEmailPreferences());
  }

  updateUserEmailPreferencesStatus(payload: any) {
    this.store.dispatch(UserDetailsActions.updateUserEmailPreferences({ payload }));
  }

  getOrganizationList() {
    this.store.dispatch(UserDetailsActions.getOrganization());
  }

  changeOrganization(payload: any) {
    this.store.dispatch(UserDetailsActions.changeOrganization({ payload }));
  }

  clearError() {
    this.store.dispatch(UserDetailsActions.clearStateOfUserDetaills());
  }

  clearUserProfileDetails() {
    this.store.dispatch(UserDetailsActions.clearUserProfileOverview());
  }

  clearUserProfileImg() {
    this.store.dispatch(UserDetailsActions.clearUserProfileImage());
  }
}
